import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { type PartnerCampaign } from '@/api/routes/partners/partners.campaigns.api';
import { type PartnerOffer } from '@/api/routes/partners/partners.offers.api';
import { campaignSummaryLabel } from '@/domain/offers/utils';
import { useTranslate } from '@/state/i18n';

interface Props {
  offer: PartnerOffer;
  campaign?: PartnerCampaign;
}

/** What the status means and the next step: the review note, the queue, the campaign. */
const OfferStatusAlert = ({ offer, campaign }: Props) => {
  const t = useTranslate('domain.offers.components.OfferStatusAlert');

  switch (offer.status) {
    case 'changes_requested':
      return (
        <Alert severity="warning">
          <AlertTitle>{t('changes_requested.title')}</AlertTitle>
          {offer.reviewNote ?? t('changes_requested.fallback')}
        </Alert>
      );
    case 'rejected':
      return (
        <Alert severity="error">
          <AlertTitle>{t('rejected.title')}</AlertTitle>
          {offer.reviewNote ?? t('rejected.fallback')}
        </Alert>
      );
    case 'in_review':
      return <Alert severity="info">{t('in_review')}</Alert>;
    case 'approved':
      return (
        <Alert severity="success">
          <AlertTitle>{t('approved.title')}</AlertTitle>
          {campaign
            ? t('approved.campaign', { summary: campaignSummaryLabel(campaign) })
            : t('approved.noCampaign')}
        </Alert>
      );
    case 'archived':
      return <Alert severity="info">{t('archived')}</Alert>;
    default:
      return null;
  }
};

export default OfferStatusAlert;
